export const SORT_OPTIONS = {
  postsCount: 'member-sort-field.posts-count',
  followerCount: 'member-sort-field.follower-count',
  newestFirst: 'member-sort-field.newest-first',
  oldestFirst: 'member-sort-field.oldest-first',
  role: 'member-sort-field.role',
};



// WEBPACK FOOTER //
// ./app/components/member-sort-field/constants.js